import React from "react";
import * as S from "./styles.js";

const CTAButton = ({
  text = "",
  onClick,
  dark,
  disabled = false,
  children,
  id,
  name,
}) => {
  return (
    <S.Button
      onClick={onClick}
      dark={dark}
      disabled={disabled}
      id={id}
      name={name}
    >
      {text}
      {children}
    </S.Button>
  );
};

export default CTAButton;
